/**
 * Quick skill suggestion pills below the input
 */
interface Props {
  onSelect: (text: string) => void
}

const SUGGESTIONS = [
  { label: '🌐 Web Scrape',    text: 'Scrape and summarize the top 5 results for: ' },
  { label: '📊 Data Analysis', text: 'Analyze this data and create a summary report: ' },
  { label: '📝 Content Gen',   text: 'Write a professional blog post about: ' },
  { label: '💻 Code Review',   text: 'Review this code and suggest improvements: ' },
  { label: '📧 Email',         text: 'Write a professional email about: ' },
  { label: '🔬 Research',      text: 'Research and summarize the latest findings on: ' },
]

export default function SkillPills({ onSelect }: Props) {
  return (
    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
      {SUGGESTIONS.map(s => (
        <button
          key={s.label}
          onClick={() => onSelect(s.text)}
          style={{
            padding: '4px 10px',
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid var(--os-border)',
            borderRadius: '7px',
            color: 'var(--os-muted)',
            fontSize: '10px',
            cursor: 'pointer',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(99,102,241,0.1)'
            e.currentTarget.style.color = '#818cf8'
            e.currentTarget.style.borderColor = 'rgba(99,102,241,0.3)'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.04)'
            e.currentTarget.style.color = 'var(--os-muted)'
            e.currentTarget.style.borderColor = 'var(--os-border)'
          }}
        >
          {s.label}
        </button>
      ))}
    </div>
  )
}
